import { ArgumentAxis } from '@devexpress/dx-react-chart-material-ui';

export const GridLine = (props: ArgumentAxis.LineProps) => (
  <line strokeDasharray={'8 8'} stroke={'#536179'} {...props} />
);
